import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { DYDX_LCD_URL } from 'src/constants/transaction';
import type { BalancePayload } from 'src/types/swr/cosmos/response';
import { get } from 'src/utils/axios';

export function useCosmosBalanceSWR(cosmosAddress?: string, config?: SWRConfiguration) {
  const requestURL = `${DYDX_LCD_URL}/cosmos/bank/v1beta1/balances/${cosmosAddress || ''}`;

  const fetcher = (fetchUrl: string) => get<BalancePayload>(fetchUrl);

  const { data, error, mutate } = useSWR<BalancePayload, AxiosError>(requestURL, fetcher, {
    dedupingInterval: 14000,
    refreshInterval: 15000,
    errorRetryCount: 5,
    isPaused: () => !cosmosAddress,
    ...config,
  });

  return { data, error, mutate };
}
